import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from './service/rest.service';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MenuIdService } from './service/menu-id.service';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import * as _moment from 'moment';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LoaderService } from './service/loader.service';
import { LoaderComponent } from './components/template/loader/loader.component';
import { NewMenuComponent } from './components/template/new-menu/new-menu.component';



export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone:true,
  imports:[
    LoaderComponent, RouterOutlet,CommonModule,NewMenuComponent
  ]
})
export class AppComponent implements OnInit {
  defaultLanguage: string = 'en'; // Default language variable
  timeInterval: any;
  isLogin: boolean = true;
  receivedData: any;
  isModules = false;
  screenConfigId: any;
  url: any;
  orgAppScreens: any;
  showHelpIcon: boolean = false;
  orgHelpScreenData: string = '';
  title!: '';
  private breadcrumbHistory: any[] = [];
  lastBreadcrumbIndex: number | null = null;
  isScrnConfig = false;
  img!: string;
  isLoginboolean: any;
  isVerficationScreen: boolean;
  logoPath: any;
  constructor(
    private titleService: Title,
    public Translate: TranslateService,
    public MenuIdService: MenuIdService,
    private restService: RestService,
    private router: Router,
    private loader: LoaderService,

  ) {
    this.loader.show();
    this.setLanguage(this.defaultLanguage); // Set the default language
    this.loadAdditionalTranslations(this.defaultLanguage);
    //document.body.classList.add('afrisure');
     //this.dynamicUIOnChange();

     // change language concept
    // const savedLang = localStorage.getItem('Language') || 'en';
    // this.Translate.setDefaultLang(savedLang);
    // this.Translate.use(savedLang);

  //   const orgAppID = 6260; // use real API later

  // this.restService.getUIConfigByOrgAppID(orgAppID).subscribe(config => {
  //   if (!config) return;

  //   document.body.classList.add(config.themeClass);
  //   this.changeBrowserTitle(config.browserTitle);
  //   this.changeFavicon(config.faviconPath);
  //   this.logoPath = config.logoPath;
  //   this.MenuIdService.setLogoPath(config.templateLogoPath);
  //   this.MenuIdService.setLandingImgPath(config.landingImagePath);
  // });
this.loadUIConfig()
  }
  loadUIConfig(): void {
    const currentUrl = window.location.href;

    // Match orgKey from URL
    const possibleKeys = ['nyala', 'kenindia', 'apa'];
    const matchedKey = possibleKeys.find(key => currentUrl.includes(key));
    console.log(matchedKey)
    if (!matchedKey) {
      console.warn('No matching org key found in URL');
      return;
    }

    this.restService.getUIConfigByOrgKey(matchedKey).subscribe(config => {
      if (!config) return;

      document.body.classList.add(config.themeClass);
      this.changeBrowserTitle(config.browserTitle);
      this.changeFavicon(config.faviconPath);
      this.logoPath = config.logoPath;
      this.MenuIdService.setCountryCode(config.countryCodeID)
      this.MenuIdService.setLogoPath(config.templateLogoPath);
      this.MenuIdService.setLandingImgPath(config.landingImagePath);
      console.log(config)
    });

     
  }
  changeLanguage(lang: string) {
    // Update the selected language
    localStorage.setItem('Language', lang);
    this.Translate.use(lang);
  }
  dynamicUIOnChange() {
    const currentUrl = window.location.href;
     switch (true) {
      case currentUrl.includes('nyala'):
        this.MenuIdService.getImagePath(6240);
        document.body.classList.add('nyala');
        this.changeBrowserTitle('Nyala');
        this.changeFavicon('assets/images/faviconLogo/nyalaFavicon.png');
        break;
       
      case currentUrl.includes('localhost'):
        this.MenuIdService.getImagePath(6240);
        document.body.classList.add('nyala');
        this.changeBrowserTitle('Nyala');
        this.changeFavicon('assets/images/faviconLogo/nyalaFavicon.png');
       
        break;
    }
  }

  ngOnInit(): void {

    this.router.events.subscribe(() => {
      let url = this.router.routerState.snapshot.url
      if (url.includes('/verification/')) {
        this.isVerficationScreen = true;
      } else {
        this.isVerficationScreen = false;
      }
    });

    // setInterval(()=>{
    //   this.isLoginboolean=localStorage.getItem('Afrisure-Token')

    // },1000)
   
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scroll(0, 0);
         this.url = event.url;
        const urlSegments = event.url.split('/');
        const idPattern =
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        const screenConfigId = urlSegments.find((segment) =>
          idPattern.test(segment)
        );

       }
    });
  }

  
 loadAdditionalTranslations(language: string) {
    this.restService
      .getData<any>('assets/apitest.json', true)
      .subscribe((data) => {
        this.Translate.setTranslation(language, {
          ...this.Translate.translations[language],
          ...data,
        });

        this.setLanguage(this.defaultLanguage);
      });
  }

  setLanguage(language: string) {
    this.Translate.setDefaultLang(language); // Set default language
    this.Translate.use(language); // Use the specified language
  }

  

  
  shoulHideMenu() {
    return (
    this.router.url.includes('error/error-status')
    );
  }
  
  changeBrowserTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  changeFavicon(newFaviconPath: string) {
    const favicon = document.getElementById(
      'dynamic-favicon'
    ) as HTMLLinkElement;
    if (favicon) {
      favicon.href = newFaviconPath;
    }
  }
  
}
